<template>
<svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.99999 4.78012C3.85661 4.78012 3.71325 4.72537 3.60394 4.61611L0.164113 1.17626C-0.0547045 0.957438 -0.0547045 0.602663 0.164113 0.383934C0.382843 0.165204 0.737548 0.165204 0.956383 0.383934L3.99999 3.42771L7.04361 0.38404C7.26243 0.165311 7.61709 0.165311 7.83581 0.38404C8.05473 0.602769 8.05473 0.957544 7.83581 1.17636L4.39603 4.61622C4.28667 4.7255 4.14331 4.78012 3.99999 4.78012Z" fill="#87939E"/>
</svg>
</template>
